export default "__VITE_ASSET__DWcIM0N0__"